export const aciCircleNotch = {
    iconName: 'circle-notch',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M3.993 12c0 4.404 3.603 8.007 8.007 8.007s8.007-3.603 8.007-8.007S16.404 3.993 12 3.993c-.8 0-1.501.1-2.202.3l-1.601-1.6c1.2-.401 2.502-.702 3.803-.702 5.505 0 10.009 4.504 10.009 10.01 0 5.504-4.504 10.008-10.009 10.008-5.505 0-10.008-4.504-10.008-10.009h2.001z',
                    fill: 'currentColor',
                    'fill-opacity': '.15',
                },
            },
            {
                attr: {
                    d: 'M11.163 19.963c4.38.46 8.34-2.746 8.8-7.126.46-4.38-2.747-8.34-7.126-8.8-4.38-.46-8.34 2.746-8.8 7.126a7.806 7.806 0 00.068 2.221l-1.76 1.425c-.272-1.236-.435-2.561-.299-3.855.576-5.475 5.526-9.483 11-8.908 5.475.576 9.483 5.526 8.908 11-.576 5.475-5.526 9.483-11 8.908l.209-1.99z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
